/**
 * @generated SignedSource<<c96f8f2f9208fa757ca4ccd9e3b21934>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ElementTypeV2 = "clozeText" | "file" | "multipleChoice" | "order" | "podcast" | "randomMultipleChoice" | "text" | "video" | "%future added value";
export type DeleteElementsPoolElementInput = {
  clientMutationId?: string | null | undefined;
  elementId: string;
  poolId: string;
};
export type MultipleChoiceElementsPool_DeleteMultipleChoiceElementV2Mutation$variables = {
  input: DeleteElementsPoolElementInput;
};
export type MultipleChoiceElementsPool_DeleteMultipleChoiceElementV2Mutation$data = {
  readonly Admin: {
    readonly Elementspool: {
      readonly deleteElementsPoolElement: {
        readonly pool: {
          readonly elements: ReadonlyArray<{
            readonly elementType: ElementTypeV2;
            readonly id: string;
            readonly question: string;
            readonly title: string;
            readonly " $fragmentSpreads": FragmentRefs<"PoolElementForm_ElementV2Fragment">;
          }>;
          readonly id: string;
        };
      } | null | undefined;
    };
  };
};
export type MultipleChoiceElementsPool_DeleteMultipleChoiceElementV2Mutation = {
  response: MultipleChoiceElementsPool_DeleteMultipleChoiceElementV2Mutation$data;
  variables: MultipleChoiceElementsPool_DeleteMultipleChoiceElementV2Mutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "elementType",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "title",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "question",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "concreteType": "File",
  "kind": "LinkedField",
  "name": "image",
  "plural": false,
  "selections": [
    (v2/*: any*/)
  ],
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "MultipleChoiceElementsPool_DeleteMultipleChoiceElementV2Mutation",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "AdminMutationType",
        "kind": "LinkedField",
        "name": "Admin",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "ElementspoolAdminMutationSchema",
            "kind": "LinkedField",
            "name": "Elementspool",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": (v1/*: any*/),
                "concreteType": "DeleteElementsPoolElementPayload",
                "kind": "LinkedField",
                "name": "deleteElementsPoolElement",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "MultipleChoiceElementsPool",
                    "kind": "LinkedField",
                    "name": "pool",
                    "plural": false,
                    "selections": [
                      (v2/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "MultipleChoiceElementV2",
                        "kind": "LinkedField",
                        "name": "elements",
                        "plural": true,
                        "selections": [
                          (v2/*: any*/),
                          (v3/*: any*/),
                          (v4/*: any*/),
                          (v5/*: any*/),
                          {
                            "args": null,
                            "kind": "FragmentSpread",
                            "name": "PoolElementForm_ElementV2Fragment"
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "MultipleChoiceElementsPool_DeleteMultipleChoiceElementV2Mutation",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "AdminMutationType",
        "kind": "LinkedField",
        "name": "Admin",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "ElementspoolAdminMutationSchema",
            "kind": "LinkedField",
            "name": "Elementspool",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": (v1/*: any*/),
                "concreteType": "DeleteElementsPoolElementPayload",
                "kind": "LinkedField",
                "name": "deleteElementsPoolElement",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "MultipleChoiceElementsPool",
                    "kind": "LinkedField",
                    "name": "pool",
                    "plural": false,
                    "selections": [
                      (v2/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "MultipleChoiceElementV2",
                        "kind": "LinkedField",
                        "name": "elements",
                        "plural": true,
                        "selections": [
                          (v2/*: any*/),
                          (v3/*: any*/),
                          (v4/*: any*/),
                          (v5/*: any*/),
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  (v6/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "answeringType",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "AnswerOptionV2",
                                    "kind": "LinkedField",
                                    "name": "answerOptions",
                                    "plural": true,
                                    "selections": [
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "answer",
                                        "storageKey": null
                                      },
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "isCorrect",
                                        "storageKey": null
                                      },
                                      (v6/*: any*/)
                                    ],
                                    "storageKey": null
                                  }
                                ],
                                "type": "MultipleChoiceElementV2",
                                "abstractKey": null
                              }
                            ],
                            "type": "ElementV2",
                            "abstractKey": "__isElementV2"
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "4da1178cd959b41efc8c3761ae22e45b",
    "id": null,
    "metadata": {},
    "name": "MultipleChoiceElementsPool_DeleteMultipleChoiceElementV2Mutation",
    "operationKind": "mutation",
    "text": "mutation MultipleChoiceElementsPool_DeleteMultipleChoiceElementV2Mutation(\n  $input: DeleteElementsPoolElementInput!\n) {\n  Admin {\n    Elementspool {\n      deleteElementsPoolElement(input: $input) {\n        pool {\n          id\n          elements {\n            id\n            elementType\n            title\n            question\n            ...PoolElementForm_ElementV2Fragment\n          }\n        }\n      }\n    }\n  }\n}\n\nfragment MultipleChoicePoolElementForm_MultipleChoiceElementV2Fragment on MultipleChoiceElementV2 {\n  id\n  title\n  question\n  image {\n    id\n  }\n  answeringType\n  answerOptions {\n    answer\n    isCorrect\n    image {\n      id\n    }\n  }\n}\n\nfragment PoolElementForm_ElementV2Fragment on ElementV2 {\n  __isElementV2: __typename\n  title\n  elementType\n  ... on MultipleChoiceElementV2 {\n    ...MultipleChoicePoolElementForm_MultipleChoiceElementV2Fragment\n  }\n}\n"
  }
};
})();

(node as any).hash = "11a74f481781343a70286cdb209c515e";

export default node;
